export enum TipoColaboradorEnum {
  ATENDENTE = "ATENDENTE",
  VISTORIADOR = "VISTORIADOR",
  GESTOR = "GESTOR",
}
